import { Injectable } from "@angular/core";
import { BulletinSecretService } from "./bulletinSecret.service";
import { SettingsService } from "./settings.service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { timeout } from "rxjs/operators";

@Injectable()
export class WalletService {
  wallet: any;
  walletproviderAddress: any;
  xhr: any;
  key: any;
  walletError = false;
  constructor(
    private ahttp: Http,
    private bulletinSecretService: BulletinSecretService,
    private settingsService: SettingsService
  ) {
    this.wallet = {
      balance: 0,
      pending_balance: 0,
      max_transferable_value: 0,
      unspent_transactions: [],
    };
  }

  get(amount_needed = 0, address = null) {
    return new Promise((resolve, reject) => {
      if (
        !this.settingsService.remoteSettings ||
        !this.settingsService.remoteSettings["walletUrl"]
      )
        return resolve(null);
      return this.walletPromise(amount_needed, address)
        .then((wallet) => {
          return resolve(wallet);
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  resolveOperatorToken() {
    const keyname = this.bulletinSecretService.keyname;
    if (!keyname) {
      return null;
    }
    if (this.settingsService.tokens[keyname]) {
      return this.settingsService.tokens[keyname];
    }
    try {
      const ls = window.localStorage.getItem("operator-jwt-" + keyname);
      if (ls) {
        this.settingsService.tokens[keyname] = ls;
        return ls;
      }
    } catch (e) {}
    return null;
  }

  walletPromise(amount_needed = 0, address = null) {
    return new Promise((resolve, reject) => {
      if (!this.settingsService.remoteSettings["walletUrl"]) {
        return reject("no wallet url");
      }
      if (
        !(
          this.bulletinSecretService.username ||
          this.bulletinSecretService.isOperator()
        )
      ) {
        this.walletError = true;
        return reject("username not set");
      }

      let headers = new Headers();
      const token = this.resolveOperatorToken();
      if (token) {
        headers.append("Authorization", "Bearer " + token);
      }
      let options = new RequestOptions({
        headers: headers,
        withCredentials: true,
      });
      const spendAddress =
        address || this.bulletinSecretService.getSpendAddress() || "";
      return this.ahttp
        .get(
          this.settingsService.remoteSettings["walletUrl"] +
            "?amount_needed=" +
            amount_needed +
            "&address=" +
            encodeURIComponent(spendAddress) +
            "&username_signature=" +
            encodeURIComponent(
              this.bulletinSecretService.username_signature || ""
            ) +
            "&origin=" +
            encodeURIComponent(window.location.origin),
          options
        )
        .pipe(timeout(30000))
        .subscribe(
          async (data) => {
            if (data["_body"]) {
              const wallet = await data.json();
              if (!address) {
                this.walletError = false;
                this.wallet = wallet;
                this.wallet.balance = parseFloat(this.wallet.balance);
                this.wallet.pending_balance = parseFloat(
                  this.wallet.pending_balance
                );
                this.wallet.max_transferable_value = parseFloat(
                  this.wallet.max_transferable_value || 0
                );
                this.wallet.balancePretty = this.wallet.balance.toFixed(2);
                this.wallet.pendingBalancePretty =
                  this.wallet.pending_balance.toFixed(2);
                this.wallet.maxTransferableValuePretty =
                  this.wallet.max_transferable_value.toFixed(2);
              }
              return resolve(wallet);
            } else {
              this.walletError = true;
              this.wallet = {};
              this.wallet.balancePretty = 0;
              this.wallet.pendingBalancePretty = 0;
              this.wallet.maxTransferableValuePretty = 0;
              this.wallet.max_transferable_value = 0;
              return reject("no data returned");
            }
          },
          (err) => {
            this.walletError = true;
            return reject("data or server error");
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/wallet.service.ts